import { auth, db, FirebaseDocRefType, FirebaseTimestamp } from 'firebase/index'
import { MessageType } from 'types/message'
import { fetchStoreByRef } from 'repos/store'
import axios from 'axios'
import { FETCH_USERS_BY_GEO } from 'constants/urls'
import { fetchStoreGeoSearch } from 'repos/storeGeoSearch'

const sendNewStoreMessage = async (storeRef: FirebaseDocRefType): Promise<void> => {
  // 商品と店舗の情報を取得
  const store = await fetchStoreByRef(storeRef)
  if (!store) return
  const storeGeoSearch = await fetchStoreGeoSearch(storeRef)
  if (!storeGeoSearch) return
  const latitude = storeGeoSearch.l.latitude
  const longitude = storeGeoSearch.l.longitude
  // トークンを再取得する
  const token = await auth.currentUser?.getIdToken()
  if (typeof !token === 'undefined') {
    console.error('認証トークンの取得に失敗しました。')
    return
  }
  try {
    // 5km圏内のユーザーを取得
    const res = await axios.post(
      FETCH_USERS_BY_GEO,
      { latitude, longitude, distance: 5 },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      }
    )
    const userIds: string[] = res.data.data
    const now = new Date()
    // 15分刻みで最も近い時刻を設定
    now.setMinutes(Math.ceil(now.getMinutes() / 15) * 15)
    now.setSeconds(0)
    now.setMilliseconds(0)
    const sendTime = FirebaseTimestamp.fromDate(new Date(now))
    const timestamp = FirebaseTimestamp.now()
    const message: MessageType = {
      body: `お近くにある${store.name}が新たに出店しました。この機会にサクッと取り置きしませんか。`,
      channel: 'bread/store',
      created_at: timestamp,
      external_link: '',
      has_sound: false,
      html: `<p>お近くにある${store.name}が新たに出店しました。この機会にサクッと取り置きしませんか。</p><img src="${store.image_urls[0]}" alt="${store.name}" style="height: auto; width: auto;" /><p>${store.name}</p>`,
      priority: 'medium',
      publish_status: '1',
      send_time: sendTime,
      store_ref: storeRef,
      title: `［新店舗のお知らせ🍞］お近くにある${store.name}が新たに出店しました。`,
      user_ids: userIds,
      updated_at: timestamp,
    }
    await db.collection('messages').doc().set(message)
  } catch (e) {
    console.error(e)
  }
}

export default sendNewStoreMessage
